import { SITE } from "@/data/site"

function Archive() {
  return (
    <section id="archive" className="relative w-full bg-[#0b0b0b]">
      <div className="grid w-full md:grid-cols-2">
        <div className="order-2 flex flex-col items-center justify-center px-8 py-28 text-center md:order-1 md:px-16 md:py-24 lg:px-20">
          <p className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]">06</p>
          <h2 className="font-display mt-10 text-4xl text-[#f7f1e6] md:mt-8 md:text-6xl">{SITE.limitLabel}</h2>
          <p className="font-sans-ui mt-10 text-3xl tracking-[0.18em] text-[#c4a574] md:mt-8 md:text-5xl">
            {SITE.priceLabel}
          </p>
        </div>
        <div className="relative order-1 mx-4 flex min-h-[56vh] items-center justify-center overflow-hidden bg-[#111111] md:order-2 md:mx-0 md:min-h-screen">
          <img
            src={SITE.productAlt}
            alt="野東西限定珍藏香氛"
            decoding="async"
            className="h-full w-full object-contain object-center"
          />
        </div>
      </div>
    </section>
  )
}

export default Archive
